// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";
// import endpoints from "../../endpoint";

// // Partner requests a withdrawal
// export const requestWithdrawal = createAsyncThunk(
//   "withdrawals/request",
//   async ({ userId, amount }, { rejectWithValue }) => {
//     try {
//       const { data } = await axios.post(
//         `${endpoints.serverBaseUrl}api/withdrawal/request`,
//         { userId, amount },
//         {
//           withCredentials: true,
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//           },
//         }
//       );
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Fetch partner withdrawals
// export const fetchPartnerWithdrawals = createAsyncThunk(
//   "withdrawals/fetchPartner",
//   async (userId = "all", { rejectWithValue }) => {
//     try {
//       const { data } = await axios.get(
//         `${endpoints.serverBaseUrl}api/withdrawal/${userId}`,
//         {
//           withCredentials: true,
//           headers: {
//             Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//           },
//         }
//       );
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // Admin approves/rejects withdrawal
// export const approveWithdrawal = createAsyncThunk(
//   "withdrawals/approve",
//   async ({ withdrawalId, status, transactionId }, { rejectWithValue }) => {
//     try {
//       const { data } = await axios.patch(
//         `${endpoints.serverBaseUrl}api/withdrawal/approve/${withdrawalId}`,
//         { status, transactionId },
//         {
//           withCredentials: true,
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//           },
//         }
//       );
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // ✅ Fetch all withdrawals (for Admin)
// export const fetchAllWithdrawals = createAsyncThunk(
//   "withdrawals/fetchAll",
//   async (_, { rejectWithValue }) => {
//     try {
//       const { data } = await axios.get(
//         `${endpoints.serverBaseUrl}api/withdrawal/all`,
//         {
//           withCredentials: true,
//           headers: {
//             Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//           },
//         }
//       );
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// const withdrawalSlice = createSlice({
//   name: "withdrawals",
//   initialState: { withdrawals: [], loading: false, error: null },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchPartnerWithdrawals.fulfilled, (state, action) => {
//         state.withdrawals = action.payload;
//         state.loading = false;
//       })
//       .addCase(requestWithdrawal.fulfilled, (state, action) => {
//         state.withdrawals.push(action.payload.withdrawal);
//       })
//       .addCase(approveWithdrawal.fulfilled, (state, action) => {
//         state.withdrawals = state.withdrawals.map((w) =>
//           w._id === action.payload.withdrawal._id
//             ? action.payload.withdrawal
//             : w
//         );
//       });
//   },
// });

// export default withdrawalSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endpoints from "../../endpoint";

// ✅ Partner requests a withdrawal
export const requestWithdrawal = createAsyncThunk(
  "withdrawals/request",
  async ({ userId, amount }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${endpoints.serverBaseUrl}api/withdrawal/request`,
        { userId, amount },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ Fetch partner withdrawals
export const fetchPartnerWithdrawals = createAsyncThunk(
  "withdrawals/fetchPartner",
  async (userId = "all", { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endpoints.serverBaseUrl}api/withdrawal/${userId}`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ Admin approves withdrawal (moves from "Processing" to "Approved")
export const approveWithdrawal = createAsyncThunk(
  "withdrawals/approve",
  async ({ withdrawalId, transactionId }, { rejectWithValue }) => {
    try {
      const { data } = await axios.patch(
        `${endpoints.serverBaseUrl}api/withdrawal/approve/${withdrawalId}`,
        { status: "approved", transactionId },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return { withdrawalId, status: "approved", transactionId };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ Admin rejects withdrawal (moves from "Processing" to "Rejected")
export const rejectWithdrawal = createAsyncThunk(
  "withdrawals/reject",
  async ({ withdrawalId, reason }, { rejectWithValue }) => {
    try {
      const { data } = await axios.patch(
        `${endpoints.serverBaseUrl}api/withdrawal/reject/${withdrawalId}`,
        { status: "rejected", reason, withdrawalId },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return { withdrawalId, status: "rejected", reason };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ Fetch all withdrawals (for Admin)
export const fetchAllWithdrawals = createAsyncThunk(
  "withdrawals/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${endpoints.serverBaseUrl}api/withdrawal/all`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ✅ Admin starts processing withdrawal (Moves from "Pending" to "Processing")
export const startProcessingWithdrawal = createAsyncThunk(
  "withdrawals/startProcessing",
  async ({ withdrawalId }, { rejectWithValue }) => {
    try {
      const { data } = await axios.patch(
        `${endpoints.serverBaseUrl}api/withdrawal/start-processing/${withdrawalId}`,
        {},
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return { withdrawalId, status: "processing" };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const withdrawalSlice = createSlice({
  name: "withdrawals",
  initialState: { withdrawals: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Partner Withdrawals
      .addCase(fetchPartnerWithdrawals.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPartnerWithdrawals.fulfilled, (state, action) => {
        state.withdrawals = Array.isArray(action.payload) ? action.payload : [];
        state.loading = false; // ✅ Ensure loading is set to false
        state.error = null;
      })
      .addCase(fetchPartnerWithdrawals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch All Withdrawals (Admin)
      .addCase(fetchAllWithdrawals.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllWithdrawals.fulfilled, (state, action) => {
        state.withdrawals = Array.isArray(action.payload) ? action.payload : [];
        state.loading = false; // ✅ Ensure loading is set to false
        state.error = null;
      })
      .addCase(fetchAllWithdrawals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Request Withdrawal
      .addCase(requestWithdrawal.pending, (state) => {
        state.loading = true;
      })
      .addCase(requestWithdrawal.fulfilled, (state, action) => {
        state.withdrawals.push({
          ...action.payload.withdrawal,
          status: "pending",
        });
        state.loading = false;
      })
      .addCase(requestWithdrawal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Approve Withdrawal
      .addCase(approveWithdrawal.pending, (state, action) => {
        const withdrawal = state.withdrawals.find(
          (w) => w._id === action.meta.arg.withdrawalId
        );
        if (withdrawal) withdrawal.status = "processing";
        state.loading = true;
      })
      .addCase(approveWithdrawal.fulfilled, (state, action) => {
        state.withdrawals = state.withdrawals.map((w) =>
          w._id === action.payload.withdrawalId
            ? {
                ...w,
                status: "approved",
                transactionId: action.payload.transactionId,
              }
            : w
        );
        state.loading = false;
      })
      .addCase(approveWithdrawal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Reject Withdrawal
      .addCase(rejectWithdrawal.pending, (state, action) => {
        const withdrawal = state.withdrawals.find(
          (w) => w._id === action.meta.arg.withdrawalId
        );
        if (withdrawal) withdrawal.status = "processing";
        state.loading = true;
      })
      .addCase(rejectWithdrawal.fulfilled, (state, action) => {
        state.withdrawals = state.withdrawals.map((w) =>
          w._id === action.payload.withdrawalId
            ? { ...w, status: "rejected", reason: action.payload.reason }
            : w
        );
        state.loading = false;
      })
      .addCase(rejectWithdrawal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(startProcessingWithdrawal.pending, (state, action) => {
        const withdrawal = state.withdrawals.find(
          (w) => w._id === action.meta.arg.withdrawalId
        );
        if (withdrawal) withdrawal.status = "pending"; // Set to "pending" while processing starts
        state.loading = true;
      })
      .addCase(startProcessingWithdrawal.fulfilled, (state, action) => {
        state.withdrawals = state.withdrawals.map((w) =>
          w._id === action.payload.withdrawalId
            ? { ...w, status: "processing" }
            : w
        );
        state.loading = false;
      })
      .addCase(startProcessingWithdrawal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default withdrawalSlice.reducer;
